module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cd-Db-Ed-Fb-Ga.b48da545.png";